'use strict';

module.exports = document.createElement('div').style;



/** WEBPACK FOOTER **
 ** ./~/domkit/builtinStyle.js
 **/